import styled from 'styled-components';

export const OfferWrap = styled.div`
  padding: 10px 0 0 0;
  position: relative;
`;

export const ButtonSpacing = styled.div`
  padding: 0 ${props => props.theme.spacing.custom(10)};
`;

export const OfferContainer = styled.div`
  padding: 0;
  margin: 0;
  width: 100%;
  float: left;
  margin-bottom: 10px;
  border-bottom-left-radius: 1em;
  border-top-left-radius: 1em;
  border-bottom-right-radius: 1em;
  border-top-right-radius: 1em;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.13) 0px 2px 4px 0px;
`;

export const CarouselOne = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
`;

export const CarouselContainer = styled.div`
  width: 9282px;
  left: 0px;
  display: block;
  transition: all 800ms ease 0s;
`;
export const ImgSection = styled.div`
  min-height: 150px;
  border-top-right-radius: 1em;
  border-top-left-radius: 1em;
  width: 100%;
  max-height: 150px;
  float: left;
  cursor: pointer;
`;
export const OfferImg = styled.img`
  width: 100%;
  max-width: 100%;
  border-top-right-radius: 1em;
  border-top-left-radius: 1em;
  min-height: 150px;
  max-height: 150px;
`;
export const OfferContent = styled.div`
  padding: 1rem 1.5rem;
  font-size: ${props => props.theme.font.custom(12)};
`;

export const OfferHeader = styled.div`
  height: 5rem;
`;

export const OfferValidity = styled.div``;

export const ViewDetails = styled.div``;

export const Prev = styled.div`
  height: 2.5rem;
  width: 2.5rem;
  position: absolute;
  left: 1rem;
  cursor: pointer;
  background-color: #ffffff;
  padding: 0.5rem;
  border-radius: 50%;
  box-shadow: 0 0 3px #ccc;
`;

export const Nxt = styled.div`
  height: 2.5rem;
  width: 2.5rem;
  position: absolute;
  right: 1rem;
  cursor: pointer;
  background-color: #ffffff;
  padding: 0.5rem;
  border-radius: 50%;
  box-shadow: 0 0 3px #ccc;
`;

export const PrevNxtWrap = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 45.5%;
  transform: translateY(-50%);
`;

export const BookButton = styled.button`
  background-color: #ff6d38;
  border-radius: 0.5rem;
  outline: none;
  padding: ${props => props.theme.spacing.custom(7)} 0;
  color: #ffffff;
  border: none;
  font-weight: 500;
  font-size: ${props => props.theme.font.custom(16)};
  cursor: pointer;
`;
